"use strict";

class PropertyLinksStoreyViewController {
    constructor($scope, $rootScope, $localStorage, $timeout, $window, Fullscreen, SSHttpService, SSUtilService, SSAppService, SSUserService, SSDisclaimerService) {

        const self = this;

        self.$scope = $scope;
        self.$rootScope = $rootScope;
        self.$storage = $localStorage;
        self.$timeout = $timeout;
        self.$window = $window;

        self.Fullscreen = Fullscreen;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSDisclaimerService = SSDisclaimerService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.init();
    }

    init() {
        const self = this;

        self.LOADING = true;

        // Drone Views, set sitemap image
        self.setSelectedDroneImage(self.findDroneImage(null, null), true);
    }

    setSelectedDroneImage(droneImage, firstLoad = false) {
        const self = this;

        if (droneImage && droneImage.file_uri) {
            self.selectedDroneImage = droneImage;
            if(!firstLoad){
                self.trackDroneViews(droneImage);
            }
        } else {
            //'/images/dronewhite.png';
            self.selectedDroneImage = null;
        }
    }

    // Drone Views
    findDroneImage(camera, level) {
        const self = this;

        let droneImage = null;

        if(self.property.property_drone_image) {
            jQuery.each(self.property.property_drone_image, function (i, _droneImage) {
                // Match Camera
                if ((camera && _droneImage.camera != camera) || (!camera && _droneImage.camera)) {
                    return;
                }
                // Match Level
                if ((level && _droneImage.level != level) || (!level && _droneImage.level)) {
                    return;
                }
                // Match found
                droneImage = _droneImage;
                return false;
            });
        }

        // Ignore Image with no URI
        if (droneImage && !droneImage.file_uri) {
            droneImage = null;
        }

        return droneImage;
    }

    toggleMenu($event) {
        // Code copied (modified version) from UI scripts to work with angular.
        let element = jQuery($event.currentTarget);
        if (element.parent().has("ul")) {
            $event.preventDefault();
        }
        if (!element.hasClass("open")) {
            // hide any open menus and remove all other classes
            jQuery(".accordion li ul").slideUp(350);
            jQuery(".accordion li a").removeClass("open");

            // open our new menu and add the open class
            element.next("ul").slideDown(350);
            element.addClass("open");
        } else if (element.hasClass("open")) {
            element.removeClass("open");
            element.next("ul").slideUp(350);
        }
    }

    toggleDroneCamera($event, droneImage, fullscreen = false) {
        const self = this;

        if (fullscreen) {
            self.setSelectedDroneImage(droneImage);
            return;
        }
        // Toggle Menu
        self.toggleMenu($event);

        if (!jQuery($event.currentTarget).hasClass('open')) {
            // If no camera button selected
            self.setSelectedDroneImage(self.findDroneImage(null, null));
        } else {
            self.setSelectedDroneImage(droneImage);
        }
    }

    // Drone Views
    trackDroneViews(droneImage){
        const self = this;

        if (!droneImage)
            return;

        let url = 'properties/droneimages/track/' + droneImage.id;
        let params = {
            data: droneImage
        };

        self.SSHttpService.postAPIRequest(url, params).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                    return;
                }
            }
        );
    }

    // Fullscreen
    showFullscreen($event) {
        const self = this;
        
        if (!self.Fullscreen.isEnabled()) {
            self.toggleFullscreen($event);
        }
    }

    closeFullscreen() {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.toggleFullscreen();
        }
    }

    toggleFullscreen($event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
        } else {
            if (!$event) return;

            if (typeof $event == "string") {
                self.Fullscreen.enable(document.getElementById($event));
            } else if ($event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable($event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable($event.currentTarget);
            }
        }
    }

}

PropertyLinksStoreyViewController.$inject = ['$scope', '$rootScope', '$localStorage', '$timeout', '$window', 'Fullscreen', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSDisclaimerService'];
app.controller('PropertyLinksStoreyViewController', PropertyLinksStoreyViewController);

